import React, { useState } from 'react';
import { makeBtStyles } from '../Theme';

import Theme from '../Theme';
import PoweredBy from '../components/PoweredBy';

import Banner from './Banner';
import StatusRow from './StatusRow';
import TrackingDetails from './TrackingDetails';
import Map from './Map';
import OrderTable from './OrderTable';


const useStyles = makeBtStyles( theme => ({
  '@global': {
    'body': {
      ...theme.page,
      background: 'white'
    },
    'a': {
      ...theme.link
    }
  },
  container: {
    minHeight: '100%',
    padding: '0 24px 36px',
    maxWidth: '1156px',
    margin: '0 auto',
    fontSize: '12px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '12px',
      paddingRight: '12px'
    }
  }
 }));

function StationLegacyLayout({ children }) {
  const classes = useStyles();

  return (
    <Theme>
      <div className={classes.container}>
        {children}
      </div>
      <PoweredBy />
    </Theme>
  );
}

const useTrackingPageStyles = makeBtStyles( theme => ({
  map: {
    width: '65.5%',
    height: '420px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '320px'
    },
    [theme.breakpoints.down('xs')]: {
      height: '200px'
    }
  },
  trackingDetails: {
    width: '32.5%',
    height: '420px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto',
      marginTop: '12px'
    }
  }
}));

function TrackingPage() {
  const [hoveredEvent, setHoveredEvent] = useState();
  const classes = useTrackingPageStyles();

  return <>
    <Banner />
    <StatusRow />
    <Map highlightEvent={hoveredEvent} className={classes.map} />
    <TrackingDetails onEventHover={setHoveredEvent} className={classes.trackingDetails} />
    <OrderTable />
  </>;
}

export default {
  Layout: StationLegacyLayout,
  TrackingPage,
  ReturnsPage: () => null
}